<script lang="ts">
  import { getContext } from 'svelte'
  import { loadInternalLink } from '#app/lib/utils'
  import ImagesCollage from '#components/images_collage.svelte'
  import { usesSubEntitiesImages } from '#entities/components/lib/sub_entities_browser_helpers'
  import type { SerializedEntity } from '#entities/lib/entities'

  const {
    entity,
  }: {
    entity: SerializedEntity
  } = $props()

  const layoutContext = getContext('layout-context')

  const type = $derived(entity.type)
</script>

<a
  href={entity.pathname}
  onclick={loadInternalLink}
  title={entity.label}
  class="sub-entity-grid-card"
  class:hasSubEntities={usesSubEntitiesImages(type)}
>
  <ImagesCollage
    imagesUrls={entity.images || []}
    limit={usesSubEntitiesImages(type) ? 6 : 1}
  />
  <div class="info">
    <h3>
      {#if layoutContext === 'serie' && entity.serieOrdinal}
        {entity.serieOrdinal}.
      {/if}
      {entity.label}
    </h3>
  </div>
</a>

<style lang="scss">
  @import "general/scss/utils";
  $card-base-width: 9em;
  $card-margin: 0.5em;
  .sub-entity-grid-card{
    @include display-flex(column, center, flex-end);
    background-color: $off-white;
    inline-size: $card-base-width;
    block-size: 12em;
    margin: $card-margin;
    &.hasSubEntities{
      inline-size: calc($card-base-width * 2 + $card-margin * 2);
    }
    &:hover{
      @include shadow-box;
    }
    position: relative;
    .info{
      @include display-flex(column, stretch, center);
      // Set a position so that the positionned image collage still appears below
      // Cf https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/Adding_z-index
      position: relative;
      block-size: 4rem;
      text-wrap: balance;
    }
    :global(.images-collage){
      @include position(absolute, 0, 0, 0, 0);
    }
  }
  .info{
    align-self: stretch;
    background-color: rgba($light-grey, 0.8);
    overflow: hidden;
  }
  h3{
    padding: 0.2em;
    $line-height: 1.1rem;
    line-height: $line-height;
    max-block-size: calc(3 * $line-height + 0.2rem);
    overflow: hidden;
    font-size: 1rem;
    text-align: center;
    margin: 0;
  }
</style>
